import React from 'react';

interface MapProps {
    className?: string;
}

export function Map({className = ''}: MapProps) {
    const placeName = 'Wojska Polskiego 9, 39-300 Mielec';

    const onClick = (event: React.MouseEvent) => {
        window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(placeName)}`, '_blank');
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <div onClick={onClick} className="size-full cursor-pointer group relative">
            <iframe
                title="Kamery Mielec - ul. Wojska Polskiego 9, 39-300 Mielec"
                src={`https://maps.google.com/maps?q=${encodeURIComponent('Wojska Polskiego 9, 39-300 Mielec')}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                width="100%"
                height="100%"
                className={"size-full select-none pointer-events-none " + className}
                allowFullScreen={false}
                loading="lazy"
            />
            <div className="absolute bottom-3 left-3 bg-card/90 backdrop-blur-md px-3 py-1.5 rounded-lg border border-border text-xs font-medium text-foreground shadow-md pointer-events-none">
                Mielec - do 250 km dojazdu
            </div>
        </div>
    );
}
